// ═══════════════════════════════════════════════════════════════
// NOUVEAUTÉS — source unique du bandeau « première ligne » vitrine
// Règle de session : chaque module/feature livré = une entrée ici
// DANS LE MÊME COMMIT (même pattern que les guides). Plus récent en premier.
// Pas de constante légale ici (R1) — uniquement des annonces produit.
// ═══════════════════════════════════════════════════════════════

export const NOUVEAUTES_LABEL = {
  fr: 'Nouveautés',
  nl: 'Nieuw',
  en: "What's new",
  de: 'Neuheiten',
};

export const NOUVEAUTES_ALL_LABEL = {
  fr: 'Tout voir',
  nl: 'Alles bekijken',
  en: 'See all',
  de: 'Alle ansehen',
};

// date : YYYY-MM-DD (affichée) · i : texte court par langue (une ligne)
export const NOUVEAUTES = [
  {
    date: '2026-07-04',
    i: {
      fr: 'Nouveau — Assistant « Situations de vie » : un événement (naissance, mariage, décès…) → tous les congés, documents et délais d\'un coup',
      nl: 'Nieuw — Assistent « Levensgebeurtenissen »: één gebeurtenis (geboorte, huwelijk, overlijden…) → alle verloven, documenten en termijnen ineens',
      en: 'New — "Life events" assistant: one event (birth, marriage, death…) → all leave, documents and deadlines at once',
      de: 'Neu — Assistent „Lebensereignisse": ein Ereignis (Geburt, Heirat, Todesfall…) → alle Urlaube, Dokumente und Fristen auf einmal',
    },
  },
  {
    date: '2026-07-04',
    i: {
      fr: 'Pointeuse → paie : les heures pointées pré-remplissent les prestations du mois en 1 clic (fini le double encodage)',
      nl: 'Prikklok → loon: geklokte uren vullen de maandprestaties in 1 klik (geen dubbele invoer meer)',
      en: 'Time clock → payroll: clocked hours pre-fill monthly work data in 1 click (no more double entry)',
      de: 'Stempeluhr → Lohn: erfasste Stunden füllen die Monatsleistungen mit 1 Klick (kein Doppelerfassen mehr)',
    },
  },
  {
    date: '2026-07-04',
    i: {
      fr: 'Roadmap 2027 ouverte : pointage universel, DmfA automatique, pont comptable — en chantier',
      nl: 'Roadmap 2027 geopend: universele tijdregistratie, automatische DmfA, boekhoudbrug — in aanbouw',
      en: '2027 roadmap open: universal time tracking, automatic DmfA, accounting bridge — in progress',
      de: 'Roadmap 2027 eröffnet: universelle Zeiterfassung, automatische DmfA, Buchhaltungsbrücke — in Arbeit',
    },
  },
  {
    date: '2026-07-02',
    i: {
      fr: 'e-Box entreprise synchronisée : vos courriers officiels ONSS lus et alertés dans l’app',
      nl: 'e-Box onderneming gesynchroniseerd: uw officiële RSZ-brieven gelezen en gemeld in de app',
      en: 'Enterprise e-Box synced: your official NSSO mail read and flagged in the app',
      de: 'e-Box Unternehmen synchronisiert: Ihre offiziellen LSS-Schreiben in der App gelesen und gemeldet',
    },
  },
  {
    date: '2026-06-29',
    i: {
      fr: 'Précompte professionnel Annexe III et bonus emploi bas salaires mis à jour',
      nl: 'Bedrijfsvoorheffing Bijlage III en werkbonus lage lonen bijgewerkt',
      en: 'Withholding tax Annex III and low-wage work bonus updated',
      de: 'Berufssteuervorabzug Anlage III und Arbeitsbonus für Niedriglöhne aktualisiert',
    },
  },
  {
    date: '2026-06-27',
    i: {
      fr: 'Tarif unique public : 29 €/fiche HTVA — zéro forfait, zéro frais d’entrée',
      nl: 'Uniek publiek tarief: 29 €/loonbrief excl. btw — geen forfait, geen instapkosten',
      en: 'Single public price: €29/payslip excl. VAT — no monthly fee, no entry fee',
      de: 'Einheitlicher öffentlicher Tarif: 29 €/Lohnzettel zzgl. MwSt. — keine Pauschale, keine Startgebühr',
    },
  },
  {
    date: '2026-06-22',
    i: {
      fr: 'Dimona automatique en production : déclarations réelles acceptées par l’ONSS',
      nl: 'Automatische Dimona in productie: echte aangiften aanvaard door de RSZ',
      en: 'Automatic Dimona in production: real declarations accepted by the NSSO',
      de: 'Automatische Dimona in Produktion: echte Meldungen vom LSS angenommen',
    },
  },
  {
    date: '2026-06-16',
    i: {
      fr: 'Module Dimona unifié : déclarations, fichier du personnel, mandats et test de connexion ONSS',
      nl: 'Eengemaakte Dimona-module: aangiften, personeelsbestand, mandaten en RSZ-verbindingstest',
      en: 'Unified Dimona module: declarations, staff register, mandates and NSSO connection test',
      de: 'Vereinheitlichtes Dimona-Modul: Meldungen, Personalregister, Mandate und LSS-Verbindungstest',
    },
  },
];
